import React from "react";

import { Box } from "@chakra-ui/react";

import WaitingTimePerServiceTable from "../../../components/organization/tables/WaitingTimePerServiceTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildDurationInsights } from "../../../store/reportEnterpriseInsights";
import { formatTime } from "../../../store/helpers";

const WaitingTimePerService = ({
  branchId = null,

  branchIndex,
  data,
  numServices=0,
  branchName="",
  renderConfig,
  onRenderConfigChange,
}) => {
  const insights = buildDurationInsights(data, {
    metric: "waiting",
    scopeLabel: "Service",
    formatDuration: formatTime,
  });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Service Waiting Time Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <WaitingTimePerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        branchIndex={branchIndex}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    </Box>
  );
};

export default WaitingTimePerService;
